fragment InboxStatusFragment on InboxStatus {
    status
    enrollmentFormStatus {
        status
        enrollmentForm {
            canSubmit
            twilioRejectionReasons
        }
    }
    phoneStatus {
        status
        nutshellChannel {
            status
            phone {
                id
                numberFormatted
            }
        }
    }
    firstMessageStatus {
        hasBeenSent
        message {
            id
            content
        }
    }
    firstCampaignStatus {
        hasBeenSent
        campaign {
            id
            name
        }
    }
    planStatus {
        status
        remainingCredits
        monthlyCredits
        usedCredits
    }
}
